var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":_vm.width,"width":_vm.height},on:{"created":_vm.onCreated,"complete":function($event){return _vm.$emit('complete')}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }